import {
  IonButton,
  IonButtons,
  IonContent,
  IonDatetime,
  IonDatetimeButton,
  IonGrid,
  IonHeader,
  IonItem,
  IonList,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonSearchbar,
  IonText,
  IonTitle,
  IonToast,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router";
import "../../components/ExploreContainer.css";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
 
import NativeSelect from '@mui/material/NativeSelect';
import InputBase from '@mui/material/InputBase';



const PostingReport = () => {
  const { name } = useParams<{ name: string }>();

  const [ledgetType, setLedgetType] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [ledgerMother, setLedgerMother] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [ratingRange, setRatingRange] = useState("0");
  const [message, setMessage] = useState("");
  const [showme, setShowme] = useState(true);
  const [ledgerName, setLedgerName] = useState("");
  const [ledgerEntry, setLedgerEntry] = useState([]);
  const [checkTeller, setcheckTeller] = useState<Boolean>(false);

  const [transMode, setTransMode] = useState("");
  const [post_sn, setPOst_sn] = useState("");
  const [transType, setTransType] = useState("");
  const [ledgerNo, setLedgerNo] = useState("");
  const [reference, setReference] = useState("");
  const [referenceDetail, setreferenceDetail] = useState("");
  const [amount, setAmount] = useState("");

  const [inputValue, setInputValue] = React.useState("");
  const [tellerFormData, SetTellerFormData] = useState([]);


  const [query, setQuery] = useState("");
  const [desp, setDesp] = useState("");
  const [squery, SetSquery] = useState("");


  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2, "0"); // January is 0, so we add 1
  var day = String(today.getDate()).padStart(2, "0");
  var formattedDate = `${year}-${month}-${day}`;

  const [posting, setPosting] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
 // const [status, setStatus] = useState({ loading: false, error: false });
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState(formattedDate);


  const checkTellerx = () => {
    checkTeller ? setcheckTeller(false) : setcheckTeller(true);

    console.log(checkTeller);
  };

  const history = useHistory();
  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  
  

   

  const top100Films = [
    { label: "The Shawshank Redemption", year: 1994 },
    { label: "The Godfather", year: 1972 },
  ];

 

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const filteredShops = posting?.filter((posting) =>
    posting?.name.toLowerCase().includes(query.toLowerCase())
  );

  const queryEmpty = () => {
    SetSquery("");
  };
  const queryKeep = (name, sn) => {
    setPOst_sn(sn);
    console.log(name, sn);
    SetSquery(name);
    setQuery("");
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
      marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }));
  
  const [age, setAge] = React.useState('');
  const handleChange = (event: { target: { value: string } }) => {
    setAge(event.target.value);
  };
  //const history = useHistory();

  useIonViewWillEnter(() => {
   // getLedgers();
   // getTellerFormData();
   getMyPostingReport();
  });

  const getMyPostingReport = async () => {
    
   
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);
      const response = await axios.post(baseUrl() + 'ledgers/getMyPostingReport', formData, config);
      console.log(response);
      const data = response.data.data;
     // setLedgerEntry(data);
      console.log(data);
      setPosting(data);
      setStatus({ loading: false, error: false });
      //setSegment("attending");
    } catch (error) {
      setStatus({ loading: false, error: true });
    }
  };


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
        

          
          </IonToolbar>
        </IonHeader>

        <Box
          sx={{
            paddingTop: "20px",
            display:'flex',
        
            "& > :not(style)": { m: 1 },
          }}
        >
          <h5> Generate Posting Reports </h5>    
     
          <Divider orientation="horizontal" flexItem />
        </Box>

        

        <Divider orientation="horizontal" flexItem />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          width:'80%',
            paddingLeft: "20px",
            marginTop:'0%',
            marginLeft:'20%',
            "& > :not(style)": { m: 1 },
          }}
        >
         
         
          
          {/* <IonItem>
            <IonLabel>Select start Date</IonLabel>

            <IonDatetimeButton datetime="datetime"></IonDatetimeButton>
            <IonModal keepContentsMounted={true}>
              <IonDatetime
                id="datetime"
                value={startDate}
                min="2024-01-01"
                presentation="date"
                max="2099-12-31"
                showDefaultButtons={true}
                onIonChange={(e) => setStartDate(e.detail.value!)}
              >
                Select End Date
              </IonDatetime>
            </IonModal>
          </IonItem> */}

       
            <IonText> Start</IonText>
            <IonDatetimeButton datetime="datetime"></IonDatetimeButton>
            <IonModal keepContentsMounted={true}>
              <IonDatetime
                id="datetime"
                value={startDate}
                min="2024-01-01"
                color={"warning"}
                presentation="date"
                max="2099-12-31"
                showDefaultButtons={true}
                onIonChange={(e) => {
                  setStartDate(e.detail.value!), getMyPostingReport();
                }}
              >
                Start
              </IonDatetime>
            </IonModal>
 
            {/*  */}
       
              <IonText slot=""> End </IonText>
              <IonDatetimeButton
              
                color={"warning"}
                datetime="datetime2"
              ></IonDatetimeButton>
              <IonModal keepContentsMounted={true}>
                <IonDatetime
                  id="datetime2"
               
                  value={endDate}
                  presentation="date"
                  min="2024-01-01"
                  color={"warning"}
                  max="2099-12-31"
                  showDefaultButtons={true}
                  onIonChange={(e) => {
                    {
                      setEndDate(e.detail.value!), getMyPostingReport();
                    }
                  }}
                >
                  {/* Select End Date */}
                </IonDatetime>
              </IonModal>
            
 


              <IonButton onClick={()=>getMyPostingReport()} mode="md" size="small" color="secondary">Generate Report </IonButton>



        </Box>

        <Divider orientation="horizontal" flexItem />
  

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          width:'99%',
            paddingLeft: "20px",
            marginTop:'1%',
           // marginLeft:'40%',
            "& > :not(style)": { m: 1 },
          }}
        >
         

         <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
      
          <StyledTableCell align="left">S/N</StyledTableCell>
            <StyledTableCell align="left">Posting Date</StyledTableCell>
            <StyledTableCell align="left">Transaction Date</StyledTableCell>
            <StyledTableCell align="left">Description </StyledTableCell>
            <StyledTableCell align="left">Dr. </StyledTableCell>
            <StyledTableCell align="left">Cr. </StyledTableCell>
            <StyledTableCell align="left">Balance </StyledTableCell>
         
          </TableRow>
        </TableHead>
        <TableBody>
          {posting?.map((row,i) => (
            <StyledTableRow key={i}>
{/* 
<StyledTableCell align="left">{i + 1}</StyledTableCell>
              <StyledTableCell  align="left" >
                {posting.uname}
              </StyledTableCell>
              <StyledTableCell align="left">{posting.email}</StyledTableCell>
              <StyledTableCell align="left">{posting.phone}</StyledTableCell>
              <StyledTableCell align="left">{posting.savingAmount}</StyledTableCell>
              <StyledTableCell align="left">{posting.sn}</StyledTableCell>
              <StyledTableCell align="left">{posting.amount}</StyledTableCell>
              <StyledTableCell align="left">{posting.amount}</StyledTableCell> */}
            </StyledTableRow>
            
          ))}
        </TableBody>
      </Table>

</Box>
        <IonLoading
          message="Logging..."
          spinner="circles"
          isOpen={status.loading}
        />
        {status.error && (
          <IonToast position="middle" isOpen={showToast} message={errorLogin} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default PostingReport;
